import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  icon?: boolean;
  fullWidth?: boolean;
  scrollTo?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon = false,
  fullWidth = false,
  className = '',
  scrollTo,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 rounded-full tracking-wide text-sm md:text-base';
  const variants = {
    primary: 'bg-accent text-navy-900 hover:bg-accent-hover shadow-[0_0_20px_rgba(224,122,240,0.3)] hover:shadow-[0_0_30px_rgba(224,122,240,0.5)] font-bold',
    secondary: 'bg-navy-700 text-white hover:bg-navy-800 border border-navy-border',
    outline: 'bg-transparent text-accent border-2 border-accent hover:bg-accent hover:text-navy-900'
  };
  const sizes = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-6 py-3',
    lg: 'px-8 py-4 text-lg'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      // Fire Meta Pixel AddToCart event before redirecting
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'AddToCart');
      }
      window.location.href = href;
      return;
    }
    if (scrollTo) {
      e.preventDefault();
      const target = document.getElementById(scrollTo);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        ${baseStyles} 
        ${variants[variant]} 
        ${sizes[size]} 
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} onClick={handleClick} {...props} data-id="element-201">
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-202" />}
    </motion.button>;
}